import type { ClientTheme } from "@/app/lib/themes"

interface LoadingStateProps {
  theme: ClientTheme
}

export function LoadingState({ theme }: LoadingStateProps) {
  return (
    <div
      style={{
        padding: "48px 0",
        textAlign: "center",
        color: theme.textMuted,
        fontFamily: "var(--font-ui)",
      }}
    >
      Loading…
    </div>
  )
}
